import React, { useCallback, memo } from 'react';
import { View } from 'react-native';
import { Avatar } from 'design-system/avatar';
import { IconProfile } from 'design-system/icons/IconProfile';
import useColors from 'hooks/useColors';
import { useAppSelector } from 'store/hooks';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectCurrentScreen } from 'reducers/selectors';
import { rem } from 'design-system';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { AVATAR_SIZE } from './constants';
const hitSlop = { left: 5, right: 5, top: 15, bottom: 15 };
const AvatarFeed = () => {
    const currentScreen = useAppSelector(selectCurrentScreen);
    const isHighlight = currentScreen === 'AccountSettings';
    const colors = useColors();
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const firstName = useAppSelector((store) => store.user.user.firstName);
    const lastName = useAppSelector((store) => store.user.user.lastName);
    const imageUrl = useAppSelector((store) => store.user.user.userImage?.url);
    const userId = useAppSelector((store) => store.user.user.id);
    const onPressAvatar = useCallback(() => {
        navigation.navigateDeprecated('AccountSettings');
    }, []);
    return (<TouchableOpacity hoverOnDark onPress={onPressAvatar} style={[
            styles.avatarContainer,
            {
                backgroundColor: isHighlight
                    ? colors.borders.iconStroke
                    : colors.background.dark,
            },
        ]} hitSlop={hitSlop}>
      <View style={styles.avatarWrapper}>
        {userId === -1 ? (<IconProfile colorKey="brand"/>) : (<Avatar name={firstName} size={AVATAR_SIZE} lastName={lastName} fontColor={colors.text.textOnBrand} imageUrl={imageUrl} color={colors.background.brandLight} small/>)}
      </View>
    </TouchableOpacity>);
};
const styleSet = createStyleSheets((colors) => ({
    avatarContainer: {
        overflow: 'hidden',
        borderRadius: rem(12),
        width: rem(56),
        height: rem(56),
        alignItems: 'center',
        justifyContent: 'center',
    },
    avatarWrapper: {
        overflow: 'hidden',
        borderWidth: rem(2),
        borderRadius: rem(32),
        alignItems: 'center',
        justifyContent: 'center',
        width: rem(AVATAR_SIZE + 4),
        height: rem(AVATAR_SIZE + 4),
        borderColor: colors.borders.logoStroke,
    },
}));
export default memo(AvatarFeed);
